import './PaymentFinePrint.css';
import React from 'react';
import { ChangePlanPaymentFinePrint, PaymentPlanFinePrint } from 'Components/FinePrint';

export const PaymentFinePrint = ({ purchaseMode = {}, ctaText, sheerIdProgram, selectedPlanId }) => {
  return (
    <div className="paymentFinePrintWrapper">
      {purchaseMode.isChangePlan && <ChangePlanPaymentFinePrint />}
      <PaymentPlanFinePrint ctaText={ctaText} sheerIdProgram={sheerIdProgram} selectedPlanId={selectedPlanId} />
    </div>
  );
};
